import { render, staticRenderFns } from "./comminfo.vue?vue&type=template&id=32ea770e&scoped=true"
import script from "./comminfo.vue?vue&type=script&lang=js"
export * from "./comminfo.vue?vue&type=script&lang=js"
import style0 from "./comminfo.vue?vue&type=style&index=0&id=32ea770e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ea770e",
  null
  
)

export default component.exports